export default __webpack_public_path__ + "static/media/bmw-m-series.4f16b47f.jpg";